export interface AnalyticsConfig {
  app: string;
  environment: string;
  isEnabled?: boolean;
  shouldTrack?: boolean;
  superAttributes?: Record<string, any>;
  eventUserAttributes?: Record<string, any>;
}

export type ClickAttributes = {
  click_type: string;
  click_text?: string;
  click_source?: string;
  link?: string;
  custom?: Record<string, any>;
};

export type LogAttributes = {
  log_type: string;
  log_value?: string;
  custom?: Record<string, any>;
};

export type PageViewAttributes = {
  page_url?: string;
  page_path?: string;
  page_title?: string;
  query_params?: Record<string, any>;
  custom?: Record<string, any>;
};

export type ViewAttributes = {
  view_type: 'Dashboard' | 'Card' | 'Modal' | 'Section' | 'Banner' | 'Drawer';
  view_name: string;
  custom?: Record<string, any>;
};

export const EVENTS = {
  identify: 'analytics.identify',
  setUserAttributes: 'analytics.set_user_attributes',
  pageView: 'analytics.pageview',
  click: 'analytics.click',
  view: 'analytics.view',
  log: 'analytics.log',
};
